import React from "react";
import { currentTenant } from "../../tenants";

export const AboutUsPage: React.FC = () => {
  const TenantAboutUsPage = currentTenant.pages.AboutUsPage;

  return <TenantAboutUsPage />;
};
